<template>
    <v-container fluid align-start ma-0 pa-1 class="container-height">
        <v-card outlined>
            <v-toolbar color="#6ECB63" @click="visible = !visible">
                <!-- <v-toolbar-title>{{ titleSalary }}</v-toolbar-title> -->
                <v-spacer></v-spacer>
                <v-btn icon>
                    <v-icon>{{ visible ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-slide-y-transition mode="in-out">
                <div v-if="visible" style="padding:5px;">
                    <v-row no-gutters fill-height>
                        <v-col cols="12">
                            <i-card-vertical headerTitle="" :useBtnList="[
                                'btnRetrieve'
                            ]" @btnRetrieve="btnRetrieve()">
                                <template v-slot:body>
                                    <v-layout column overflow-auto>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-card class="d-flex align-center justify-center" min-height="40">
                                                    
                                                    <v-col cols="6" ms="6" md="4">
                                                        <v-text-field label="Employee Code" v-model="empNo" dense outlined
                                                            prepend-inner-icon="mdi-account" :disabled="disabled"
                                                            hide-details="auto" @keydown.enter="btnRetrieve()" clearable />
                                                    </v-col>
                                                </v-card>
                                                    
                                            </v-col>
                                        </v-row>
                                    </v-layout>
                                </template>
                            </i-card-vertical>
                        </v-col>
                    </v-row>
                </div>
            </v-slide-y-transition>
        </v-card>
        <v-card class="pt-1">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-data-table :headers="headers" :items="detailPICs" class="elevation-1">
                        <template v-slot:top>
                            <v-dialog v-model="dialog" 
                                      persistent
                                      transition="dialog-bottom-transition" 
                                      scrollable
                                      fullscreen
                                      >
                                <!-- <v-card flat shaped> -->
                                <v-card flat>    
                                    <v-card-title class="d-flex cyan darken-1" 
                                       :style="{'padding': '0', 'letter-spacing': '0.0125em'}">
                                        <v-card-title dense class="text-subtitle-1 ">
                                            {{ formTitle }}
                                        </v-card-title>
                                        <v-spacer></v-spacer>
                                                                               
                                    </v-card-title>
                                    
                                   
                                </v-card>
                            </v-dialog>
                        </template>
                        <template v-slot:item.no="{ item }">
                            <v-chip color="primary" variant="outlined">
                                {{ item.no }}
                            </v-chip>
                            <v-chip class="ma-1" color="primary" variant="outlined">
                                {{ item.enm }}
                            </v-chip>
                            
                        </template>
                        <template v-slot:item.deptNm="{ item }">
                            <span color="#F3E99F" variant="outlined">
                                {{ item.deptNm }} 
                            </span>
                        </template> 
						
						<template v-slot:item.grpNm="{ item }">
                            <span color="#F3E99F" variant="outlined">
                                {{ item.grpNm }}
                            </span>
                        </template> 
                        
                        <template v-slot:item.posNm="{ item }">
                            <span color="#E76161">
                                {{ item.posNm }}
                            </span>
                        </template>
                        <template v-slot:item.password="{ item }">
                            <span color="#E76161">
                                {{ item.password }}
                            </span>
                        </template>
                        
                       
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
       
        <v-btn v-show="scY > 50" fab small color="primary" app fixed right bottom @click="scrollToTop()">
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
        <VueToastify :notifyAction="notifyAction"></VueToastify>
    </v-container>
</template>
  
<script>
import {getv10a6000, vni2unicode } from '@/api/view/mis/10/v10a6000.js';
import baseview from '@/components/base/baseview.vue';
import ICardVertical from '@/components/common/iCardVertical.vue';
import DxDateBox from 'devextreme-vue/date-box';
import notify from 'devextreme/ui/notify' // message
import VueToastify from '@/components/toastify/VueToastify.vue'
import { DxScrollView } from "devextreme-vue/scroll-view";


function conVert(text) {
    let result = text;
    for (let i = 0; i < text.length; i++) {
        result = result.replace('-', '');
    }
    return result;
}
export default {
    mixins: [baseview],
    components: {
        ICardVertical,
        DxDateBox,
        VueToastify,
        DxScrollView     
    },
    data: () => ({
        dialog: false,

        headers: [   
			{ text: 'Tên', align: 'center', value: 'enm', sortable: false },  
			{ text: 'Phòng', align: 'center', value: 'deptNm', sortable: false },                  
            { text: 'Nhóm', align: 'center', value: 'grpNm', sortable: false },
            { text: 'Chức vụ', align: 'center', value: 'posNm', sortable: false },            
            { text: 'Mật khẩu', align: 'end', value: 'password', sortable: false },           
           
        ],        
       
        menu: false,
        modal: false,
        empNo: '',
        detailPICs: [],
        details: [],
        scTimer: 0,
        scY: 0,
        formTitle: '',
        visible: true,        
        disabled: false,
       
        date:'',
    }),

    created() {
        // this.get_Month(new Date() )
        this.getList()       
        window.addEventListener('scroll', this.handleScroll);
        
    },

    methods: {

        handleScroll: function () {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },

        notifyAction(notifyInfo, action) {
            this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
        },        
        
        btnRetrieve() {
            
            this.get10a6000()
        },
        async get10a6000() {
            this.openLoading('searching')
            let params = {
                empNo: !this.empNo ? '' : this.empNo,               
            }
			
            await getv10a6000(params).then(res => {
                let list = []
                let cnt = 1;
                res.list.forEach(e => {

                    list.push(
                        {
                            id: cnt++, password: e.password, deptNm: e.deptNm, grpNm: e.grpNm, 
                            enm: e.enm, posNm: e.posNm,                             
                            
                        }
                    )
                  
                })
				

                if (list.length < 1) {
                    this.vToastify(this.$t('No data'), 'warn')
                    return
                } else {
                    this.detailPICs = list
                    this.visible = false
                }
            }).finally(() => {
                this.endLoading()

            })
        },
        
        scrollToTop() {
            window.scrollTo(0, 0);
        }
    },
}
</script>
<style >
* {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
}

/* tao duong line o table vuejs*/
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
    border-right: 1px solid white;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td:not(.v-data-table__mobile-row),
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row) {
    border-right: 1px solid rgb(209, 208, 208);

}

/*tang khoang cach cua 2 gia tri tren mobile*/
.v-data-table>.v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 0px;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    padding: 4px;
}

/*tang khoang cach cua 2 gia tri tren mobile*/
.v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row {
    border-radius: 10px;
    padding: 10px;
    margin: 5px;
    border: 1px solid #ededed;
    display: block;
    background-color: rgb(233, 242, 252);
}

.v-data-table-header {
    background-color: rgb(233, 242, 252);
    font-weight: bold;
    text-align: center;
    justify-content: center;
    padding: 0%;
}

/* .v-dialog > .v-card > .v-card__title {
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: 0.0125em;
    padding: 5px;
} */

</style>